import React from "react";
import { graphql } from "gatsby";

export const ParagraphsContent = ({ node }) => (
  <div>
    <div dangerouslySetInnerHTML={{ __html: node.text.processed }} />
  </div>
);

export const fragment = graphql`
  fragment ParagraphsContent on paragraph__content {
    id
    text: field_content {
      format
      processed
      value
    }
  }
`;
